import { render, staticRenderFns } from "./search_infoTags.vue?vue&type=template&id=b7e31c6e"
import script from "./search_infoTags.vue?vue&type=script&lang=js"
export * from "./search_infoTags.vue?vue&type=script&lang=js"
import style0 from "./search_infoTags.vue?vue&type=style&index=0&id=b7e31c6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports